"use client";

import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

/**
 * The centred card the admin shows when nobody is signed in yet — the sign-in
 * screen and the OAuth callback, in all three admin apps.
 *
 * Six copies of the same two nested divs, which is why it is here. It is also
 * the one admin screen that renders OUTSIDE AdminLayout, so it cannot borrow
 * that shell's chrome and has to state its own page box.
 */
export function AuthCard({
  title,
  subtitle,
  children,
  logoUrl,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  /** The company's logo, shown before the title when the server knows one. */
  logoUrl?: string;
}) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Paper variant="outlined" sx={{ p: 5, width: "100%", maxWidth: 400 }}>
        <Typography
          variant="h5"
          component="h1"
          sx={{ textAlign: "center", mb: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 1.25 }}
        >
          {logoUrl && (
            <Box
              component="img"
              src={logoUrl}
              alt=""
              sx={{ height: 48, width: "auto", maxWidth: 160, borderRadius: 0.5, objectFit: "contain", flexShrink: 0 }}
            />
          )}
          {title}
        </Typography>
        {subtitle != null && (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", mb: 3 }}>
            {subtitle}
          </Typography>
        )}
        {children}
      </Paper>
    </Box>
  );
}

export default AuthCard;
